import moment from 'moment'

export function formatDateLine(date) {
	return moment(date).format('MM / DD / YYYY')
}

export function formatDateLineExport(date) {
	return new Date(date)
}


export const columnsOffence = [
	{
		dataField: 'reportId',
		text: 'Report',
		sort: true
	},
	{
		dataField: 'offenceLevel',
		text: 'Offence Level',
		sort: true
	},
	{
		dataField: 'office',
		text: 'Office',
		sort: true
	},
	{
		dataField: 'comite',
		text: 'Committee',
		sort: true
	},
	{
		dataField: 'reportCreatedDate',
		text: 'Created Date',
		sort: true,
		formatter: formatDateLine
	}
]

export const columnsOffenceExport = [
	{ title: 'Report', value: 'reportId' },
	{ title: 'Offence Level', value: 'offenceLevel' },
	{ title: 'Office', value: 'office' },
	{ title: 'Committee', value: 'comite' },
	{ title: 'Created Date', value: (row) => formatDateLineExport(row.reportCreatedDate) },
]


export const columnsActions = [
	{
		dataField: 'reportId',
		text: 'Report',
		sort: true
	},
	{
		dataField: 'conclusion',
		text: 'Conclusion',
		sort: true
	},
	{
		dataField: 'actionTitle',
		text: 'Actions',
		sort: true
	},
	{
		dataField: 'office',
		text: 'Office',
		sort: true
	},
	{
		dataField: 'commite',
		text: 'Committee',
		sort: true
	},
	{
		dataField: 'reportCreatedDate',
		text: 'Created Date',
		sort: true,
		formatter: formatDateLine
	}
]

export const columnsActionsExport = [
	{ title: 'Report', value: 'reportId' },
	{ title: 'Conclusion', value: 'conclusion' },
	{ title: 'Action', value: 'actionTitle' },
	{ title: 'Office', value: 'office' },
	{ title: 'Committee', value: 'commite' },
	{ title: 'Created Date', value: (row) => formatDateLineExport(row.reportCreatedDate) },
]